import React from 'react'

import { handleDirectionByAddress } from 'helpers/linkingActions'

import { defaultStyles as styles } from './styles'
import cssStyles from './ProviderContacts.module.scss'

export const ProviderContacts = ({ locations, phone }) => {
  return (
    <div style={styles.container}>
      <div style={styles.titleContainer}>
        <span className={cssStyles.firstColumn} style={styles.firstTitle}>
          Practice Locations {`(${locations.items[0].length})`}
        </span>
        <span className={cssStyles.secondColumn} style={styles.secondTitle}>
          Phone
        </span>
      </div>
      {locations.items[0].length > 0 && locations.items[0].map((location, index) => (
        <div key={index} style={{ ...styles.dataContainer, ...index !== 0 && styles.border }}>
          <div className={cssStyles.firstColumn} style={styles.locationsContainer}>
            <div style={styles.address}>
              {location.address}
            </div>
            <span
              onClick={() => handleDirectionByAddress(location.address)}
              style={styles.addressLink}
            >
              Get Directions ›
            </span>
          </div>
          <div className={cssStyles.secondColumn} style={styles.phoneContainer}>
            <a href={`tel:${phone}`} style={styles.phone}>
              {phone}
            </a>
          </div>
        </div>
      ))}
    </div>
  )
}
